/**
 * src/data/templateGuide.js — chữ giúp người dùng CHỌN mẫu và BẮT ĐẦU dùng mẫu.
 *
 * Tách khỏi dữ liệu mẫu vì đây là lời hướng dẫn biên tập, không phải thuộc
 * tính của tệp. Mẫu mới chưa có dòng ở đây vẫn hiện bình thường: "Bạn nhận
 * được" lấy câu đầu của phần mô tả, "Bắt đầu" dùng hướng dẫn chung.
 *
 * Các câu ở đây lấy từ tệp (mẫu sinh từ code, hai tệp trong noi-dung/mau) hoặc
 * từ danh sách sheet và lưu ý người soạn khai trong /admin/mau (30/09/2026).
 * Sửa tệp thì đối chiếu lại câu tương ứng.
 */

/** Nhóm mẫu gọi theo VIỆC người dùng cần làm. */
export const VIEC_CUA_NHOM = {
  dashboard: 'Trình bày số cho nhà đầu tư',
  'mo-hinh-tai-chinh': 'Lập kế hoạch tài chính',
  'bao-cao-tai-chinh': 'Lập báo cáo tài chính',
  'dinh-gia': 'Ước tính định giá',
  'co-phan': 'Tính tỷ lệ sở hữu',
  'chi-so-hoat-dong': 'Theo dõi chỉ số hoạt động',
  'due-diligence': 'Chuẩn bị hồ sơ thẩm định',
  'quan-ly-goi-von': 'Theo dõi tiếp cận nhà đầu tư',
};

/** Một câu về đầu ra chính. */
export const KET_QUA_MAU = {
  'dashboard-bao-cao-nha-dau-tu': 'Một trang báo cáo tháng gửi nhà đầu tư, có số so với tháng trước, xu hướng 6 tháng và runway.',
  'dashboard-chuoi-fnb': 'Lợi nhuận tại điểm của từng điểm bán, giá trị một hoá đơn, tỷ lệ giá vốn, tiền thuê và thời gian hoàn vốn mở điểm.',
  'dashboard-thuong-mai-dien-tu': 'Phễu từ lượt truy cập tới đơn giao thành công, doanh thu thực sau hoàn huỷ, ROAS và chi phí có một khách mới.',
  'dashboard-cong-no-phai-thu': 'Số tiền đang nằm ở khách theo tuổi nợ, khách nợ nhiều nhất và số ngày thu tiền bình quân.',
  'dashboard-dong-tien-13-tuan': 'Số dư tiền mặt từng tuần trong 13 tuần tới, tuần tiền thấp nhất và runway sau 13 tuần.',
  'mo-hinh-tai-chinh-saas': 'Doanh thu, chi phí, tiền mặt và runway 12 tháng, kèm LTV, CAC payback và burn multiple.',
  'mo-hinh-tai-chinh-chuoi-fnb': 'Doanh thu từng điểm bán, dòng tiền 12 tháng và thời gian hoàn vốn một điểm bán.',
  'mo-hinh-tai-chinh-thuong-mai-dien-tu': 'Doanh thu sau hoàn hàng, chi phí quảng cáo, tiền mặt và runway 12 tháng.',
  'mo-hinh-tai-chinh-36-thang-saas': 'Ba báo cáo tài chính 36 tháng, nhu cầu vốn và tháng tiền mặt thấp nhất.',
  'dinh-gia-startup-dcf': 'Khoảng định giá trước vòng theo năm phương pháp và tỷ lệ cổ phần phải nhượng.',
  'cap-table-pha-loang-safe': 'Tỷ lệ sở hữu của từng bên qua bốn mốc, sau SAFE, ESOP và vòng mới.',
  'so-sanh-term-sheet': 'Định giá thực, tỷ lệ founder còn lại và số tiền founder nhận ở ba mức giá bán, cho ba term sheet cạnh nhau.',
  'bo-ho-so-tham-dinh-data-room': 'Danh mục 52 tài liệu quỹ sẽ hỏi, có cột trạng thái và sheet đếm tài liệu còn thiếu.',
  'theo-doi-tiep-can-nha-dau-tu': 'Danh sách quỹ đã tiếp cận, ngày cần nhắc lại và phễu từ gửi hồ sơ tới thẩm định.',
};

/** Sau khi tải: mở đâu trước, nhập gì, kiểm tra gì. */
export const BAT_DAU_MAU = {
  'mo-hinh-tai-chinh-36-thang-saas': [
    'Mở sheet Inputs: chỉ nhập vào ô nền vàng, các ô còn lại là công thức.',
    'Điền kế hoạch tuyển dụng ở sheet Nhan_su, rồi xem sheet Dashboard.',
    'Mở sheet Kiem_tra: phải báo OK trước khi gửi cho nhà đầu tư.',
  ],
  'dinh-gia-startup-dcf': [
    'Đọc sheet Huong_dan, rồi mở sheet Dau_vao.',
    'Chỉ sửa ô chữ xanh nền vàng; thay số ví dụ và dữ liệu so sánh bằng số thật, ghi nguồn.',
    'Xem khoảng định giá tổng hợp ở sheet Tong_hop.',
  ],
  'cap-table-pha-loang-safe': [
    'Đọc sheet Huong_dan, rồi nhập số cổ phần, SAFE và vòng mới ở sheet Dau_vao.',
    'Xem tỷ lệ sở hữu qua từng mốc ở sheet Pha_loang và Tong_hop.',
    'Mở sheet Kiem_tra để chắc tổng tỷ lệ đúng trước khi dùng số.',
  ],
  'bo-ho-so-tham-dinh-data-room': [
    'Đọc sheet Hướng dẫn, rồi cập nhật cột trạng thái ở sheet Danh mục hồ sơ.',
    'Ghi người phụ trách, hạn và đường dẫn file cho từng tài liệu.',
    'Sheet Tiến độ tự đếm số tài liệu bắt buộc còn thiếu.',
  ],
  'so-sanh-term-sheet': [
    'Ở sheet So sánh, nhập ba mức giá bán công ty bạn muốn xem.',
    'Mỗi cột một term sheet: điền số tiền, định giá, ESOP, ưu đãi thanh lý và chọn mười điều khoản đúng như văn bản ghi.',
    'Đọc khối Tóm tắt: dòng founder nhận khi bán ở mức vừa và số cờ đỏ quan trọng hơn dòng định giá.',
  ],
  'theo-doi-tiep-can-nha-dau-tu': [
    'Đọc sheet Hướng dẫn, rồi thêm quỹ vào sheet Danh sách quỹ.',
    'Ghi từng lần trao đổi ở sheet Nhật ký liên hệ.',
    'Sheet Phễu & tiến độ tự tính tỷ lệ qua từng bước và cảnh báo quỹ quá hạn.',
  ],
};

/** Mẫu sinh từ code (12 tháng) đều cùng cấu trúc bốn tab. */
export const BAT_DAU_MAU_SINH = [
  'Mở tab Giả định: đây là tab duy nhất bạn nhập số, mỗi giả định có ô ghi nguồn.',
  'Thay số ví dụ bằng số của bạn; tab Mô hình tự tính lại.',
  'Xem tab Tóm tắt: các con số quỹ hỏi trước tiên, gồm tháng hết tiền.',
];

export const ketQuaMau = (mau) =>
  KET_QUA_MAU[mau.slug] || String(mau.excerpt || '').split(/(?<=\.)\s/)[0];

export const batDauMau = (mau) =>
  BAT_DAU_MAU[mau.slug] || (mau.kind === 'sinh' ? BAT_DAU_MAU_SINH : null);
